export interface IUpsellCta {
  text: string;
  url: string;
  callback: () => void;
}

export interface IBodyContent {
  heading: string;
  descriptions: string[];
}

export interface IFailureState extends IBodyContent {
  ctaText: string;
}

export interface IAccountManagerDetails {
  name: string;
  email: string;
  phoneNumber: string;
  thumbnail: string;
  emailClickCallback: () => void;
  phoneClickCallback: () => void;
}

export interface IGeneralUpsellConfig {
  imageUrlDesktop: string;
  imageUrlMobile: string;
  heading: string;
  description: string;
  primaryCta: IUpsellCta;
  secondaryCta: IUpsellCta;
  footerDescription: string;
  isUpsellSubmitted: boolean;
  isUpsellSubmissionSuccessful: boolean;
  accountManager: IAccountManagerDetails;
  submissionFailureContent: IFailureState;
  submissionSuccessfulContent: IBodyContent;
}

export const GENERAL_UPSELL_DEFAULT_CONFIG: IGeneralUpsellConfig = {
  imageUrlDesktop: '',
  imageUrlMobile: '',
  heading: '',
  description: '',
  isUpsellSubmitted: false,
  isUpsellSubmissionSuccessful: true,
  primaryCta: {
    text: '',
    url: '',
    callback: null,
  },
  secondaryCta: {
    text: $localize`Learn more`,
    url: 'https://gomotive.com/products/',
    callback: null,
  },
  footerDescription: $localize`Contact your Motive Account Manager to upgrade.`,
  accountManager: {
    name: '',
    email: 'sales@gomotive.com',
    phoneNumber: '+1 855-434-3564',
    thumbnail: 'https://keep-truckin-preview.s3.amazonaws.com/uploads/admin_user/photo_upload/4/44b8c6ae.png',
    emailClickCallback: null,
    phoneClickCallback: null,
  },
  submissionSuccessfulContent: {
    heading: $localize`Thank you`,
    descriptions: [
      $localize`We\'ve received your request, your motive account manager will reach out to you within one business day`,
    ],
  },
  submissionFailureContent: {
    heading: $localize`Unexpected error`,
    descriptions: [
      $localize`Sorry, we didn\'t receive your request. Please refresh the page or try again later.`,
    ],
    ctaText: $localize`Retry`,
  },
};

// add names in lower case
export const accountManagerNamesToIgnore: string[] = ['frank williams'];
